import { useState } from "react";
import "./ContactForm.css";

// Set this via env (e.g., VITE_API_BASE or REACT_APP_API_BASE)
const API_BASE = process.env.REACT_APP_API_BASE || ""; // "" = same-origin


export default function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ sending: false, ok: null, msg: "" });

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();

    console.log("API_BASE =", process.env.REACT_APP_API_BASE);
    // quick client-side guard
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus({ sending: false, ok: false, msg: "All fields are required." });
      return;
    }

    setStatus({ sending: true, ok: null, msg: "" });
    try {
      const res = await fetch(`${API_BASE}/v1/contacts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // if you need cookies for auth later: credentials: "include",
        body: JSON.stringify(form),
      });

      // Try to parse JSON; fallback to empty object/string
      let data = null;
      try { data = await res.json(); } catch { /* ignore parse errors */ }

      if (!res.ok) {
        const serverMsg =
          (data && (data.error || data.message)) || `HTTP ${res.status}`;
        throw new Error(serverMsg);
      }

      //const msgId = data?.id ? ` (id: ${data.id})` : "";
      setStatus({ sending: false, ok: true, msg: `Message sent` });
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus({
        sending: false,
        ok: false,
        msg: err?.message || "Error sending message",
      });
    }
  };

  return (
    <div className="form-center">
      <form className="contact-form" onSubmit={onSubmit} noValidate>
        <h1
          style={{
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: "1.05",
            fontSize: "clamp(48px, 9vw, 100px)",
            marginBottom: "25px",
          }}
        >
          Contact Us
        </h1>

        <div className="form-field">
          <label htmlFor="name" className="label">Name</label>
          <input
            id="name"
            name="name"
            type="text"
            className="input"
            required
            value={form.name}
            onChange={onChange}
            autoComplete="name"
          />
        </div>

        <div className="form-field">
          <label htmlFor="email" className="label">Email</label>
          <input
            id="email"
            name="email"
            type="email"
            className="input"
            required
            value={form.email}
            onChange={onChange}
            autoComplete="email"
          />
        </div>

        <div className="form-field">
          <label htmlFor="message" className="label">Message</label>
          <textarea
            id="message"
            name="message"
            className="textarea"
            rows={5}
            required
            value={form.message}
            onChange={onChange}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="button-submit" disabled={status.sending}>
            <h1>{status.sending ? "Sending…" : "Send"}</h1>
          </button>
        </div>

        {status.ok === true && <p className="success">{status.msg}</p>}
        {status.ok === false && <p className="error">{status.msg}</p>}
      </form>
    </div>
  );
}
